import React from 'react';
import SVGIcon, { BASE_ICONS } from 'src/components/svg';
import { colors, fileAreaStyle, fileAreaWebExtra } from './styles';
import { View } from 'components/basic';

// Renders a DICOM file as a clickable icon that opens the OHIF viewer.
// Note: click is handled directly via onClick (no DOM ref simulation like the
// old class component used) — simpler and works the same way on RN's <Pressable>.
function DcmPreview({ width, onClick }) {
  const iconWidth = width >= 140 ? width * 0.6 : 50;

  return (
    <View
      onClick={onClick}
      title='Open in OHIF Viewer'
      style={{ ...fileAreaStyle, ...fileAreaWebExtra }}
    >
      <SVGIcon iconname={BASE_ICONS.FILE_DCM} width={iconWidth} fill={colors.primary} />
    </View>
  );
}

export default DcmPreview;
